import React, { Component } from 'react';
import { Link, Navigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default class ErrorHandling  extends Component {

    

    render() {

        // var userToken = localStorage.getItem('token');
        // if(! userToken) {
        //       return <Navigate  to='/login' replace="true" />
        //   }

          var example = JSON.stringify({
            "success": false,
            "message": "Invalid Session"
            }, null, 2)

        return (
            <div>
                <div class="docs-content">
                    <div class="container">
                    <article class="docs-article">
                        <section class="docs-section">

                            <h1 class="docs-heading">
                                Error Handling
                            </h1>

                            <h2 class="section-heading">Standard Error Response</h2>

                            <p>
                                All APIs return a consistent error response format when a request cannot be processed.
                            </p>

                            <pre>
                                <code class="copybox-code">
                    {example}
                                </code>
                            </pre>

                        </section>
                    </article>

                    <article class="docs-article">
                        <section class="docs-section">

                            <h2 class="section-heading">HTTP Status Codes</h2>

                            <table class="table table-bordered table-white">
                                <thead>
                                    <tr>
                                        <th>Code</th>
                                        <th>Description</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr>
                                        <td>200</td>
                                        <td>Success</td>
                                    </tr>

                                    <tr>
                                        <td>400</td>
                                        <td>Invalid Request</td>
                                    </tr>

                                    <tr>
                                        <td>401</td>
                                        <td>Unauthorized</td>
                                    </tr>

                                    <tr>
                                        <td>500</td>
                                        <td>Internal Server Error</td>
                                    </tr>
                                </tbody>
                            </table>

                        </section>
                    </article>

                    <article class="docs-article">
                        <section class="docs-section">

                            <h2 class="section-heading">Common Validation Errors</h2>

                            <table class="table table-bordered table-white">
                                <thead>
                                    <tr>
                                        <th>Error</th>
                                        <th>Description</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr>
                                        <td>Invalid Signature</td>
                                        <td>HMAC validation failed.</td>
                                    </tr>

                                    <tr>
                                        <td>Invalid Session</td>
                                        <td>Session ID expired, invalid, or already used.</td>
                                    </tr>

                                    <tr>
                                        <td>Invalid Corridor</td>
                                        <td>Unsupported payout corridor.</td>
                                    </tr>

                                    <tr>
                                        <td>Invalid Amount</td>
                                        <td>Amount outside the permitted range.</td>
                                    </tr>

                                    <tr>
                                        <td>Missing Required Field</td>
                                        <td>A mandatory field was not supplied.</td>
                                    </tr>

                                    <tr>
                                        <td>Invalid Branch Code</td>
                                        <td>Branch code not found.</td>
                                    </tr>

                                    <tr>
                                        <td>Invalid Location</td>
                                        <td>Payout institution not supported.</td>
                                    </tr>

                                    <tr>
                                        <td>Transaction Failed</td>
                                        <td>The transaction could not be processed.</td>
                                    </tr>
                                </tbody>
                            </table>

                        </section>
                    </article>

                    <article class="docs-article">
                        <section class="docs-section">

                            <h2 class="section-heading">Comments</h2>

                            <ul>
                                <li>
                                    This error may be returned by any API that requires a valid <code>session_id</code>.
                                </li>

                                <li>
                                    It indicates that the provided <code>session_id</code> is expired, invalid, already used, or does not belong to the current transaction flow.
                                </li>

                                <li>
                                    Partners must stop the current transaction flow and generate a new <code>session_id</code> by calling the <b>Get Available Corridors</b> API again.
                                </li>

                                <li>
                                    The newly generated <code>session_id</code> must be used for all subsequent API requests in the new transaction flow.
                                </li>
                            </ul>

                        </section>
                    </article>

                        <article class="docs-article" id="section-3">
                            <section class="docs-section row" id="item-3-1">
                                <div class="col-12">
                                    <nav aria-label="Page navigation example">
                                        <ul class="pagination justify-content-between">
                                        <li class="page-item">
                                            <Link
                                                class="page-link"
                                                to="/merchant-dependency-matrix"
                                                tabIndex="-1"
                                                aria-disabled="true"
                                            >
                                                <i class="bi bi-arrow-left"></i>&nbsp;
                                                Dependency Matrix
                                            </Link>
                                        </li>

                                        <li class="page-item">
                                            <Link
                                                class="page-link"
                                                 to="/merchant-get-countries"
                                            >
                                                Get Countries&nbsp;
                                                <i class="bi bi-arrow-right"></i>
                                            </Link>
                                        </li>
                                        </ul>
                                    </nav>
                                </div>

                            </section>

                        </article>

                    </div>
                </div>
                <ToastContainer closeOnClick autoClose={2000}></ToastContainer>
            </div >
        )
    }

}